import { useRef } from 'react';
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import StatusOptionsMulti from '../components/psc/lib/StatusOptionsMulti'
import SearchBox from '../components/psc/lib/SearchBox'
import GncDataTable from '../components/psc/lib/GncDataTable'
import Loading from '../components/psc/lib/Loading'

import useAuthentication from '../hooks/useAuthentication';
import useUserManagement from '../hooks/useUserManagement';
import useTableSlots from '../hooks/useTableSlots';
import useQualityContents from '../hooks/useQualityContents';
import useQmsDocumentStatuses from '../hooks/useQmsDocumentStatuses';
import useBrowserTabTitle from '../hooks/useBrowserTabTitle';

const QmsDocuments = () => {
    useBrowserTabTitle('QMS Documents')

    const table = useRef(null)
    const localStorageOrderKey = 'tblQmsDocumentsOrder'
    const localStorageStatusKey = 'tblQmsDocumentsStatus'
    const defaultOrder = [[ 0, 'desc' ]]
    
    const pscState = useSelector(state => state.pscState.value)
    const config = pscState.config || {}

    const hasIsoSectionNumber = parseInt(config.qms_documents_has_iso_section_number,10) || 0
    const hasAreaField = parseInt(config.qms_documents_has_area_field,10) || 0

    const { currentUser } = useAuthentication();

    const {
        userHasRole,
        isUserManagementInitialized
    } = useUserManagement()

    const {
        qmsDocuments,
    } = useQualityContents()

    const {
        qmsDocumentStatuses,
    } = useQmsDocumentStatuses()

    const {
        dateSlot,
        filePathSlot,
        linkSlot,
        ownerSlot
    } = useTableSlots()

    const columns = [
        { data: 'final_version_file_path' },
        { data: 'created_at' },
        { data: 'reference' },
        { data: 'title' },
        { data: 'area_name' },
        { data: 'qms_document_type_name' },
        { data: 'iso_section_number' },
        { data: 'owner_user_id' },
        { data: 'qms_document_status_name' }
    ]
    // possibly hide ISO Section Number
    if( ! hasIsoSectionNumber ) {
        columns[6] = { ...columns[6], visible: false, searchable: false }
    }
    // possibly hide area field
    if( ! hasAreaField ) {
        columns[4] = { ...columns[4], visible: false, searchable: false }
    }

    const tableHead = (
        <tr>
            <th style={{width: '25px'}}>&nbsp;</th>
            <th>Added</th>
            <th>Reference</th>
            <th>Title</th>
            <th>Area</th>
            <th>Type</th>
            <th>ISO</th>
            <th>Owner</th>
            <th>Status</th>
        </tr>
    )

    const tableSlots = {
        0: filePathSlot,
        1: dateSlot,
        2: (data, type, row) => linkSlot(data, type, row, `/qms_documents/${row.id}`),
        3: (data, type, row) => linkSlot(data, type, row, `/qms_documents/${row.id}`),
        5: (data, type, row) => {
            if( type !== 'display') {
                return data
            }
            let value = data
            if (row.incorporated_in_projects?.length > 0) {
                value = (
                    <span>{data}
                        <i className="fa fa-share-alt" data-tooltip-id="gnctooltip" data-tooltip-content="Shared Document"></i>
                    </span>
                )
            }
            return value
        },
        7: ownerSlot
    }

    if (!isUserManagementInitialized) {
        return <Loading />
    }
    
    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">

                        <div className="ibox-title">
                            <h2>QMS Documents</h2>

                            { userHasRole(currentUser, 'qms_documents_user') &&
                                <Link type="button" className="btn btn-mr btn-primary" to="/qms_documents/new">New QMS Document</Link>
                            }
                        </div>

                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                                <StatusOptionsMulti
                                    tableRef={table}
                                    statusColumnIndex="8"
                                    data={qmsDocumentStatuses}
                                    localStorageKey={localStorageStatusKey}
                                />
                            </div>

                            <GncDataTable
                                    tableRef={table}
                                    data={qmsDocuments}
                                    defaultOrder={defaultOrder}
                                    localStorageOrderKey={localStorageOrderKey}
                                    columns={columns}
                                    tableSlots={tableSlots}
                                    tableHead={tableHead}
                                    tableFoot={tableHead}
                                />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default QmsDocuments
